module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Lu_Meldung3.f491bca5.png";